import { FC, PropsWithChildren, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useFetch } from 'use-http'
import useCookie from 'react-use-cookie'
import { useLocation, useNavigate } from 'react-router'
import { Box, CircularProgress, HStack, Text, useColorModeValue } from '@chakra-ui/react'
import { TOKEN_KEY, actions, getUserIdFromToken, isExpired } from '../../store/slices/User/reducer'
import LoginPage from '../Login'
import { api, makeHeaders } from '../../util/api'

const AuthPage: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useCookie(TOKEN_KEY);
  const bgColor = useColorModeValue('gray.100', 'gray.900');
  const fontColor = useColorModeValue('gray.600', 'gray.100');

  const {
    get,
    error,
    response,
    cache,
    loading,
  } = useFetch(`${api}/users`, {
    interceptors: {
      request: async () => makeHeaders(),
    }
  });


  useEffect(() => {
    if (token && isExpired(token)) {
      setToken('');
      dispatch(actions.clear());
    }

    if (!token) {
      dispatch(actions.clear());
    }

    if (!token && location.pathname !== '/acceso') {
      navigate('/acceso');
    }

    if (token && location.pathname === '/acceso') {
      navigate('/');
    }

  }, [dispatch, token, setToken, location.pathname, navigate]);

  const fetchUserDetails = async () => {
    if (!token) return;
    const userId = getUserIdFromToken(token);

    if (!userId) return;
    cache.clear();
    dispatch(actions.setLoading(true));

    const user = await get(`/${userId}`);

    if (response.ok && !error) {
      dispatch(actions.setUser(user));
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, [token]); // eslint-disable-line

  if (loading) {
    return (
      <Box
        height='100vh'
        color={fontColor}
        bgColor={bgColor}
        justifyContent='center'
        display='flex'
        alignItems='center'
      >
        <HStack>
          <CircularProgress
            isIndeterminate
            color='brand.500'
            size={8}
          />
          <Text fontSize='lg' fontWeight='medium'>Cargando...</Text>
        </HStack>
      </Box>
    )
  }

  if (token) {
    return <>{children}</>
  }

  return <LoginPage setToken={setToken} onAccess={fetchUserDetails} />
}

export default AuthPage;
